import { defineMessages } from '@cookbook/solid-intl'

// Split out of `points-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Discover Lodgr points with Lodgr. Earn rewards on every stay you book. Redeem your points to save on future bookings.',
        id: 'PointsPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Lodgr Points | Lodgr',
        id: 'PointsPage.titleMessage',
    }),
}
